import React from 'react'
import { wrapper } from '../../components/button/button.module.scss'

const Button = () => {
    return <button type="submit"
        className={wrapper}
    >Send&nbsp;<span className="font-awesome-wrapper"></span></button>
}

export default Button